<template>
    <div class="container-fluid">
        <Breadcrumb title="PMTA Relays - Mail Service Report" v-bind:button-show="false"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <label>Relay Group</label>
                            <treeselect v-model="filter.relayGroup" placeholder="All Relays" :multiple="false"
                                :options="relayGroupList" :load-options="loadRelayGroupList"
                                :auto-load-root-options="true" />
                        </div>
                        <div class="input-group form-group">
                            <label>Mail Service</label>
                            <treeselect v-model="filter.mailProvider" placeholder="Select Mail Service"
                                :multiple="false" :options="mailProviderList" :load-options="loadMailProviderList"
                                :auto-load-root-options="true" />
                            <div v-if="$v.filter.mailProvider.$error">
                                <div class="text-danger" v-if="!$v.filter.mailProvider.required">Mail Service is
                                    required.</div>
                            </div>
                        </div>
                        <div class="input-group form-group">
                            <label>Date Range</label>
                            <date-picker v-model="range" range style="width:100%;" :lang="datePickerConf"></date-picker>
                        </div>
                        <div class="input-group form-group">
                            <label>Relay description</label>
                            <input v-model="filter.description" type="text" class="form-control form-control-line w-100"
                                placeholder="Search by relay description">
                        </div>
                        <div class="form-row">
                            <div class="col-2">
                                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light w-100"
                                    @click="getReport()">
                                    Get
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{ preloader: loading }"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="report.length === 0">{{ emptyMessage }}</div>
                            <div v-else>
                                <div id="bounceStatsHtml" v-show="false">
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Bounce Category</th>
                                                    <th>Count</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(bounce, index) in bounceStats" :key="index">
                                                    <td>{{ bounce.bounce_cat }}</td>
                                                    <td>{{ bounce.cnt }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div>
                                    <div class="table-responsive">
                                        <table class="table table-header-rotated">
                                            <thead>
                                                <tr>
                                                    <th @click="tableOrdering('id')">
                                                        <span role='button'>ID</span>
                                                    </th>
                                                    <th v-if="showGroupName" @click="tableOrdering('groupName')">
                                                        <span role='button'>Group</span>
                                                    </th>
                                                    <th @click="tableOrdering('isVps')">
                                                        <span role='button'>Type</span>
                                                    </th>
                                                    <th @click="tableOrdering('ip')">
                                                        <span role='button'>IP</span>
                                                    </th>
                                                    <th @click="tableOrdering('smtpHost')">
                                                        <span role='button'>Hostname</span>
                                                    </th>
                                                    <th @click="tableOrdering('switchOff')">
                                                        <span role='button'>On/Off</span>
                                                    </th>
                                                    <th @click="tableOrdering('speed')">
                                                        <span role='button'>Speed</span>
                                                    </th>
                                                    <th @click="tableOrdering('description')">
                                                        <span role='button'>Description</span>
                                                    </th>
                                                    <th class="rotate-45">
                                                        <div role='button' @click="tableOrdering('delivered')">
                                                            Delivered
                                                        </div>
                                                        <div role='button' @click="tableOrdering('deliveredLH')">
                                                            /Last Hour
                                                        </div>
                                                    </th>
                                                    <th class="rotate-45">
                                                        <div role='button' @click="tableOrdering('bounced')">
                                                            Bounced
                                                        </div>
                                                        <div role='button' @click="tableOrdering('bouncedLH')">
                                                            /Last Hour
                                                        </div>
                                                    </th>
                                                    <th class="rotate-45" @click="tableOrdering('views')">
                                                        <span role='button'>Views</span>
                                                    </th>
                                                    <th class="rotate-45" @click="tableOrdering('clicks')">
                                                        <span role='button'>Clicks</span>
                                                    </th>
                                                    <th class="rotate-45" @click="tableOrdering('conversions')">
                                                        <span role='button'>Conv</span>
                                                    </th>
                                                    <th class="rotate-45" @click="tableOrdering('profit')">
                                                        <span role='button'>Profit</span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(relay, index) in report" :key="index"
                                                    :class="{ 'bg-rose': relay.stopped }">
                                                    <td class="align-middle">
                                                        <router-link
                                                            :to="{ name: 'pmtaRelayFilter3', params: { relayId: relay.id } }">
                                                            {{ relay.id }}
                                                        </router-link>
                                                    </td>
                                                    <td class="align-middle" v-if="showGroupName">
                                                        {{ relay.groupName }}
                                                    </td>
                                                    <td class="align-middle">{{ relay.isVps ? 'VPS' : 'Net' }}</td>
                                                    <td class="align-middle">{{ relay.ip }}</td>
                                                    <td class="align-middle">
                                                        <a :href="'http://' + relay.smtpHost + ':9999/ui/config'"
                                                            target="_blank">{{ relay.smtpHost }}</a>
                                                    </td>
                                                    <td>
                                                        <div v-show="waitingSwitch === index"
                                                            class="spinner-grow spinner-grow-sm" role="status"></div>
                                                        <toggle-button v-show="waitingSwitch !== index"
                                                            :value="!relay.switchOff" sync color="#00c292"
                                                            @change="changeSwitch(index)"
                                                            :labels="{ checked: 'On', unchecked: 'Off' }" :height="20"
                                                            :width="52">
                                                        </toggle-button>
                                                    </td>
                                                    <td class="align-middle">
                                                        <i role='button' class="fas fa-edit pb-2" aria-hidden="true"
                                                            @click="editRelaySpeed(relay.id, relay.speed)"
                                                            style="font-size: 12px;">
                                                        </i>

                                                        <span class="ml-2">
                                                            {{ relay.speed === null ? '' : relay.speed }}
                                                        </span>

                                                        <i style="font-size: 0.75em;" class="fas fa-circle ml-2"
                                                            v-if="relay.speed !== null"
                                                            v-bind:style="{ 'color': relay.speedIsGood ? '#2fff00' : '#ffe533' }">
                                                        </i>

                                                        <i role='button' class="fas fa-ban pb-2 ml-2" aria-hidden="true"
                                                            v-if="relay.speed !== null"
                                                            @click="deleteRelaySpeed(relay.id)"
                                                            style="font-size: 12px;">
                                                        </i>
                                                    </td>
                                                    <td class="align-middle">
                                                        <i role='button' class="fas fa-edit pb-2 mr-2"
                                                            aria-hidden="true"
                                                            @click="editRelayDescription(relay.id, relay.description)"
                                                            style="font-size: 12px;">
                                                        </i>
                                                        {{ relay.description }}
                                                    </td>
                                                    <td class="align-middle">
                                                        <a :href="'https://' + relay.smtpHost + ':9999/ui/queues/*/' + relay.smtpHost + '_' + mailProviderList.find((element) => element.id === filter.mailProvider).label"
                                                            target="_blank">
                                                            <span v-tooltip.top="'dlvrd'">
                                                                {{ relay.delivered }} / {{ relay.deliveredLH }}
                                                            </span>
                                                        </a>
                                                    </td>
                                                    <td class="align-middle links">
                                                        <span v-tooltip.top="'bounce'" role='button' @click="getBounceStats(relay.id)">
                                                            {{ relay.bounced }} / {{ relay.bouncedLH }}
                                                        </span>
                                                        <div v-if="waitBounceStats === relay.id" class="spinner-grow spinner-grow-sm" role="status"></div>
                                                    </td>
                                                    <td class="align-middle">
                                                        <span v-tooltip.top="'view'">{{ relay.views }}</span>
                                                    </td>
                                                    <td class="align-middle">
                                                        <span v-tooltip.top="'click'">{{ relay.clicks }}</span>
                                                    </td>
                                                    <td class="align-middle">
                                                        <span v-tooltip.top="'Conv'">{{ relay.conversions }}</span>
                                                    </td>
                                                    <td class="align-middle">
                                                        <span v-tooltip.top="'Profit'">{{ relay.profit }}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="swalHtml" v-show="false">
            <textarea v-model="descriptionEditor" ref='swalHtml' placeholder="Add description here"></textarea>
        </div>
    </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import Swal from 'sweetalert2'
import Preloader from '../components/Preloader';
import Breadcrumb from '../components/Breadcrumb';
import ReportService from '../services/ReportService';
import PmtaRelayGroupService from '../services/PmtaRelayGroupService';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import MailProviderService from '../services/MailProviderService';
import PmtaRelayService from '../services/PmtaRelayService';
import PmtaSpeedService from '../services/PmtaSpeedService';
import PmtaRelayMailProviderSwitchService from '../services/PmtaRelayMailProviderSwitchService';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'PmtaRelaysMailServiceReport',
    components: {
        Treeselect,
        Breadcrumb,
        Preloader,
        DatePicker
    },
    data() {
        return {
            report: [],
            emptyMessage: 'Select Mail Service',
            relayGroupList: null,
            mailProviderList: null,
            filter: {
                relayGroup: null,
                mailProvider: null,
                fromDate: null,
                toDate: null,
                orderBy: 'delivered',
                asc: false,
                description: null
            },
            loading: false,
            waitRelay: null,
            isAdmin: false,
            range: [moment().subtract(7, 'days').toDate(), moment().toDate()],
            datePickerConf: {
                formatLocale: {
                    firstDayOfWeek: 1,
                },
            },
            descriptionEditor: '',
            showGroupName: true,
            waitingSwitch: null,
            bounceStats: [],
            waitBounceStats: null
        }
    },
    mounted() {
        this.isAdmin = this.$store.getters.isAdmin;
    },
    validations: {
        filter: {
            mailProvider: { required }
        }
    },
    methods: {
        changeSwitch(index) {
            this.waitingSwitch = index;
            PmtaRelayMailProviderSwitchService.updateSwitch(this.report[index].id, this.filter.mailProvider, !this.report[index].switchOff).then((response) => {
                this.waitingSwitch = null;
                if (response.data.success) {
                    this.report[index].switchOff = !this.report[index].switchOff
                }
            });
        },
        loadRelayGroupList({ callback }) {
            PmtaRelayGroupService.getGroupSelect().then(response => {
                this.relayGroupList = response.data['hydra:member'].map(group => {
                    return { id: group.id, label: group.name }
                });
                callback();
            });
        },
        loadMailProviderList({ callback }) {
            MailProviderService.getProviderSelect().then(response => {
                this.mailProviderList = response.data['hydra:member'].map(group => {
                    return { id: group.id, label: group.name }
                });
                callback();
            });
        },
        getReport: function () {
            this.$v.$touch();
            if (this.$v.$invalid) return;

            this.showGroupName = this.filter.relayGroup == null ? true : false;
            this.filter.fromDate = moment(this.range[0]).format('YYYY-MM-DD');
            this.filter.toDate = moment(this.range[1]).format('YYYY-MM-DD');
            this.loading = true;
            ReportService.getPmtaRelaysMailServiceReport(JSON.stringify(this.filter)).then(response => {
                if (response.status !== 200) {
                    Swal({
                        type: 'error',
                        title: 'Error',
                        text: (response.data.error === undefined) ? response.status + ': ' + response.statusText : response.data.error[0]
                    });
                    this.loading = false;
                    return;
                }
                this.report = response.data.report;
                this.emptyMessage = 'No data found.';
                this.loading = false;
            }).catch(error => {
                Swal({
                    type: 'error',
                    title: 'Oops...',
                    text: `${error}`,
                });
                this.loading = false;
            });
        },
        tableOrdering(field) {
            if (this.filter.orderBy === field) {
                this.filter.asc = !this.filter.asc;
            } else {
                this.filter.orderBy = field;
                this.filter.asc = false;
            }
            this.getReport();
        },
        editRelayDescription(relayId, description) {
            Swal({
                input: "textarea",
                title: "Description",
                inputValue: description,
                showCancelButton: true,
                showLoaderOnConfirm: true,
                preConfirm: (input) => {
                    return PmtaRelayService.editDescription(relayId, input).catch(error => {
                        Swal.showValidationMessage(
                            'Error: ' + error.response.data.error[0]
                        )
                    });
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.value.status === 200) {
                    let index = this.report.findIndex(line => line.id === relayId);
                    this.report[index].description = result.value.data.value;
                }
            })
        },
        editRelaySpeed(relayId, speed) {
            Swal({
                input: "textarea",
                title: "Speed",
                inputValue: speed,
                showCancelButton: true,
                showLoaderOnConfirm: true,
                preConfirm: (input) => {
                    return PmtaSpeedService.easyEditSpeed(relayId, this.filter.mailProvider, input).catch(error => {
                        Swal.showValidationMessage(
                            'Error: ' + error.response.data.error[0]
                        )
                    });
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.value.status === 200) {
                    if (!result.value.data.success) {
                        Swal(
                            'Error',
                            result.value.data.msg,
                            'error'
                        )
                        return;
                    }
                    if (result.value.data.speed !== null) {
                        let index = this.report.findIndex(line => line.id === relayId);
                        this.report[index].speed = result.value.data.speed;
                        this.report[index].speedIsGood = result.value.data.isGoodSpeed;
                        return;
                    }
                } else {
                    Swal(
                        'Error',
                        result.value.data.error[0],
                        'error'
                    )
                }
            })
        },
        deleteRelaySpeed(relayId) {
            PmtaSpeedService.easyDeleteSpeed(relayId, this.filter.mailProvider).then(response => {
                if (response.status !== 200) {
                    Swal({
                        type: 'error',
                        title: 'Error',
                        text: (response.data.error === undefined) ? response.status + ': ' + response.statusText : response.data.error[0]
                    });
                    return;
                }
                let index = this.report.findIndex(line => line.id === relayId);
                this.report[index].speed = null;
            }).catch(error => {
                Swal({
                    type: 'error',
                    title: 'Oops...',
                    text: `${error}`,
                });
            });
        },
        async getBounceStats(relayId) {
            this.waitBounceStats = relayId;
            let swalHtml = '';
            await PmtaRelayService.getRelayBounceStats(relayId, this.filter).then(response => {
                if (response.status === 200) {
                    this.bounceStats = response.data.list;
                } else {
                    swalHtml = (response.data.error === undefined) ? response.status + ': ' + response.statusText : response.data.error
                }
                this.waitBounceStats = null;
            }).catch(error => {
                this.waitBounceStats = null;
                swalHtml = error;
            });
            await Swal({
                title: 'Bounce Stats',
                html: swalHtml === '' ? document.getElementById('bounceStatsHtml').innerHTML : swalHtml,
                confirmButtonText: 'Close',
            });
        },

    }
}
</script>

<style scoped>
tbody {
    font-size: 14px;
    font-family: Arial, serif;
}

#relay-host {
    color: #146da6;
    font-weight: 400;
}

.table-header-rotated th.rotate-45 {
    height: 80px;
    position: relative;
    vertical-align: bottom;
    padding: 0;
    font-size: 12px;
}

.table-header-rotated th.rotate-45 span {
    -ms-transform: rotate(270deg);
    -moz-transform: rotate(270deg);
    -webkit-transform: rotate(270deg);
    -o-transform: rotate(270deg);
    transform: rotate(270deg);
    position: absolute;
    bottom: 40px;
    left: -25px;
    width: 85px;
}

.bg-rose {
    background-color: #ffebe9;
}
.links {
    color: #0056f3;
}
</style>
